import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const IdentityPasswordWUT = props => {
  const fieldType = FIELD_TYPES.IDENTITY_PASSWORD;
  const {
    label
  } = props;
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    type: "password",
    fieldType: fieldType,
    label: label
  }));
};
//# sourceMappingURL=identity-password-wut.js.map